import type { FC, PropsWithChildren} from "react";
import { createContext, useContext, useEffect, useState } from "react";

import { Device, type IViewportInfo, calculateViewport } from "@Components/Modules/ViewportResize";

export const ViewportInfoContext = createContext<IViewportInfo>(null);

export const useViewportInfoContext = () => useContext(ViewportInfoContext);

let initialRender = true;

export const ViewportInfoContextProvider: FC<PropsWithChildren<{ device: Device }>> = ({
    device,
    children,
}) => {
    const [viewportInfo, setViewportInfo] = useState(
        calculateViewport(device === Device.Desktop ? 1300 : 600),
    );

    useEffect(() => {
        const setViewport = () => {
            const viewport = calculateViewport(window.innerWidth);
            if (viewport.device !== viewportInfo.device) {
                setViewportInfo(viewport);
            }
        };

        if (initialRender) {
            setViewport();
            initialRender = false;
        }

        window.addEventListener("resize", setViewport);

        return () => window.removeEventListener("resize", setViewport);
    }, [viewportInfo]);

    return (
        <ViewportInfoContext.Provider value={viewportInfo}>{children}</ViewportInfoContext.Provider>
    );
};
